import type { TweetFeedResponseTweetsItemContent } from './tweetFeedResponseTweetsItemContent';
import type { TweetFeedResponseTweetsItemMediaItem } from './tweetFeedResponseTweetsItemMediaItem';
import type { TweetFeedResponseTweetsItemPoll } from './tweetFeedResponseTweetsItemPoll';
import type { TweetFeedResponseTweetsItemStats } from './tweetFeedResponseTweetsItemStats';
import type { TweetFeedResponseTweetsItemTags } from './tweetFeedResponseTweetsItemTags';
import type { TweetFeedResponseTweetsItemTweetType } from './tweetFeedResponseTweetsItemTweetType';

export type TweetFeedResponseTweetsItem = {
  authorDisplayName?: string;
  authorId?: string;
  authorProfileImageUrl?: string;
  authorUsername?: string;
  content?: TweetFeedResponseTweetsItemContent;
  createdAt?: string;
  isLiked?: boolean;
  isRetweeted?: boolean;
  media?: TweetFeedResponseTweetsItemMediaItem[];
  poll?: TweetFeedResponseTweetsItemPoll;
  /**
   * ID of the referenced tweet (for replies and quotes)
   * @nullable
   */
  referencedTweetId?: string | null;
  stats?: TweetFeedResponseTweetsItemStats;
  tags?: TweetFeedResponseTweetsItemTags;
  tweetId?: string;
  /** Type of tweet */
  tweetType?: TweetFeedResponseTweetsItemTweetType;
  updatedAt?: string;
};
